import { Injectable } from '@angular/core';
import { AccountLimits } from "../interfaces/form-model";
import { BehaviorSubject, map, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AccountLimitsService {
  private restrictAccess$ = new BehaviorSubject<boolean>(true);

  constructor(private http: HttpClient) { }

  private getAccountLimits(): Observable<AccountLimits> {
    return this.http.get<AccountLimits>(`${window.location.origin}/ui-forms/v1/account-limits`);
  }

  public initAccountLimits() {
    this.getAccountLimits()
      .pipe(
        map(accountLimits => accountLimits.restrictAccess),
      ).subscribe(value => this.restrictAccess$.next(value))
  }

  public hasRestrictAccess(): Observable<boolean> {
    return this.restrictAccess$.asObservable();
  }
}
